import { ActivityTracker, NamespaceLoggerAdapter } from '@fluidx/telemetry';
import { isGetLabelEnabled, isSetLabelEnabled } from './utilities/informationProtectionSettingsUtilities';
/**
 * A helper method that returns an implementation of InformationProtectionService for containers backed by Sharepoint.
 * @param props The parameters required to instantiate the implementation
 */
export function getInformationProtectionServiceForSharepoint(props) {
    let sharepointInformationProtectionServicePromise = undefined;
    if (isGetLabelEnabled(props.settingsProvider)) {
        sharepointInformationProtectionServicePromise = import('./SharepointInformationProtectionService').then((m) => {
            const service = new m.SharepointInformationProtectionService({
                ...props,
                logger: props.logger ? new NamespaceLoggerAdapter('InformationProtectionService', props.logger) : undefined
            });
            // Ensure the sensitivity data is cached
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            service.initialize();
            return service;
        });
    }
    if (props.logger) {
        const logger = new NamespaceLoggerAdapter('InformationProtectionService', props.logger);
        const tracker = ActivityTracker.start('getInformationProtectionServiceForSharepoint', logger);
        tracker.setResult(sharepointInformationProtectionServicePromise !== undefined /* suceeded */, {
            isGetLabelEnabled: isGetLabelEnabled(props.settingsProvider),
            isSetLabelEnabled: isSetLabelEnabled(props.settingsProvider),
            settingsProviderExists: props.settingsProvider !== undefined
        });
    }
    return sharepointInformationProtectionServicePromise;
}
//# sourceMappingURL=getInformationProtectionServiceForSharepoint.js.map